module.exports = __webpack_public_path__ + "06_long_gold.7a2effea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_long_gold.png
// module id = y+tg
// module chunks = 0